import { devtools, persist } from 'zustand/middleware';
import create from 'zustand';

import { User } from '@modules/core/types';
import { PartnerOrganization } from '@modules/core/types/partnerType.type';
import { Permissions } from '@modules/permissions/types';
import { AuthState, UserSettingsState } from './useAuthStore.types';

const useAuthStore = create(
  devtools(
    persist(
      (set) => ({
        user: null,
        partner: null,
        permissions: [],
        settings: null,
        isLoggingOut: false,
        login: (user: User) =>
          set(() => ({
            user,
          })),
        logout: () =>
          set(() => ({
            user: null,
          })),
        updateUser: (user: User) => {
          set(() => ({
            user,
          }));
        },
        updateSettings: (settings: UserSettingsState) => {
          set(() => ({
            settings,
          }));
        },
        updatePartner: (partner: PartnerOrganization) => {
          set(() => ({
            partner,
          }));
        },
        updatePermissions: (permissions: Permissions[]) => {
          set(() => ({
            permissions,
          }));
        },
        updateIsLoggingOut: (isLoggingOut: boolean) => {
          set(() => ({
            isLoggingOut,
          }));
        },
      }),
      {
        name: 'auth',
        getStorage: () => sessionStorage,
        partialize: (state: AuthState) => ({ user: state?.user, partner: state?.partner }),
      },
    ),
  ),
);

export default useAuthStore;
